import { GeneralData } from 'components/flash-sale/flash-sale-create/general-data/GeneralData'
import { useEffect, useState } from 'react'

export const GeneralDataContainer = ({ sectionRef, flashSaleDetail, onChangeForm, errorForm }) => {
    const TIME_DEFAULT = '00:00'
    const [date, setDate] = useState({ start: null, end: null })
    const [time, setTime] = useState({ start: null, end: null })

    const onChangeDateTime = ({ name, value }) => {
        let newItem = {}
        switch (name) {
            case 'start_date':
                newItem = { date_start: `${value} ${time?.start || TIME_DEFAULT}` }
                break
            case 'end_date':
                newItem = { date_expired: `${value} ${time?.start || TIME_DEFAULT}` }
                break
            case 'start_time':
                newItem = { date_start: `${date?.start} ${value || TIME_DEFAULT}` }
                break
            case 'end_time':
                newItem = { date_expired: `${date?.end} ${value || TIME_DEFAULT}` }
                break
            default:
                return
        }
        onChangeForm(newItem)
    }

    useEffect(() => {
        const splitStartDate = flashSaleDetail?.date_start?.split(' ')
        const splitEndDate = flashSaleDetail?.date_expired?.split(' ')
        setDate({ start: splitStartDate?.[0] || null, end: splitEndDate?.[0] || null })
        setTime({ start: splitStartDate?.[1] || null, end: splitEndDate?.[1] || null })
    }, [flashSaleDetail?.date_start, flashSaleDetail?.date_expired])

    const propsGeneralData = {
        sectionRef: sectionRef?.general_data,
        flashSaleDetail,
        onChangeForm,
        errorForm,
        date,
        time,
        onChangeDateTime,
    }

    return <GeneralData {...propsGeneralData} />
}
